// ./firebase/firebase.js

import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

// ✅ BookMatchup Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAXku_YQ3OllGINGbmL1leKeGAt6HUasyw",
  authDomain: "bookmatchup.firebaseapp.com",
  projectId: "bookmatchup",
  storageBucket: "bookmatchup.appspot.com", // ✅ Fixed this line
  messagingSenderId: "488650809043",
  appId: "1:488650809043:web:5564433802e05372bcbe26",
  measurementId: "G-5W9HMPEZZ6"
};

// ✅ Initialize Firebase app
const app = initializeApp(firebaseConfig);

// ✅ Initialize Analytics
const analytics = getAnalytics(app);

// ✅ Set up Authentication and Google provider
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

// ✅ Export initialized services
export { app, analytics, auth, googleProvider };
